function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.25 13a1.52 1.52 0 101.52 1.52A1.52 1.52 0 007.25 13zm0 2.19a.67.67 0 11.67-.67.67.67 0 01-.67.63zM12.58 13a1.52 1.52 0 101.52 1.52A1.53 1.53 0 0012.58 13zm0 2.19a.67.67 0 010-1.34.67.67 0 110 1.34zM13 5H6.87a.43.43 0 000 .85H13A.43.43 0 0013 5zM12.63 7.16H7.21a.43.43 0 100 .85h5.42a.43.43 0 000-.85z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.1 3.06a.83.83 0 00-.66-.31H3.22L3 1.45a.87.87 0 00-.54-.61L.59 0A.41.41 0 000 .26a.41.41 0 00.26.55l1.86.81 2.05 10a.85.85 0 00.83.68h10.18a.43.43 0 000-.85H5l-.25-1.21h10.5a.86.86 0 00.84-.68l1.18-5.76a.83.83 0 00-.17-.74zm-1.85 6.3H4.58L3.39 3.6h13.05z"
});

function SvgShoppingCart(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 17.29 16"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "assets/images/shopping-cart.83f9ac16.svg";
export { SvgShoppingCart as ReactComponent };